import React from 'react';
const SvgVssx = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...props}>
      <path fill="#FFF" d="M13 4h30v40H13z" />
      <g fill="#C8C8C8">
        <path d="M16 7v16h11V7H16zm10 1v14h-9V8h9zM16 25v16h11V25H16zm10 1v14h-9V26h9zM30.222 7H29v16h11V7h-9.778zM39 22h-9V8h9v14zM29 25v16h11V25H29zm10 1v14h-9V26h9z" />
      </g>
      <path fill="#949494" d="M12 3v42h32V3H12zm31 41H13V4h30v40z" />
      <path fill="#3955A3" d="M4 17l20-3v26L4 37z" />
      <path
        fill="#FFF"
        d="M19 21l-3.665 12H12.62L9 21h2.582l2.218 8.351c.118.452.19.851.215 1.197h.044c.035-.373.112-.783.23-1.23L16.493 21H19z"
      />
      <linearGradient id="vssx_svg__a" gradientUnits="userSpaceOnUse" x1={11.049} y1={3.798} x2={44.951} y2={44.202}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#vssx_svg__a)" d="M44 3H12v42h32V3z" />
      <linearGradient id="vssx_svg__b" gradientUnits="userSpaceOnUse" x1={33.67} y1={9.83} x2={42.23} y2={1.27}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#vssx_svg__b)" d="M12 3v1h31v24h1V3z" />
      <linearGradient id="vssx_svg__c" gradientUnits="userSpaceOnUse" x1={17.754} y1={42.918} x2={18.177} y2={38.93}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.17} stopColor="#7e7e7e" stopOpacity={0.034} />
        <stop offset={0.346} stopColor="#717171" stopOpacity={0.069} />
        <stop offset={0.525} stopColor="#5d5d5d" stopOpacity={0.105} />
        <stop offset={0.706} stopColor="#404040" stopOpacity={0.141} />
        <stop offset={0.886} stopColor="#1b1b1b" stopOpacity={0.178} />
        <stop offset={0.997} stopOpacity={0.2} />
      </linearGradient>
      <path fill="url(#vssx_svg__c)" d="M24 43H12v-4.8L24 40z" />
      <linearGradient id="vssx_svg__d" gradientUnits="userSpaceOnUse" x1={14} y1={39.188} x2={14} y2={14.758}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.859} stopColor="#fff" stopOpacity={0.155} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.18} />
      </linearGradient>
      <path fill="url(#vssx_svg__d)" d="M24 14L4 17v20l20 3z" />
    </svg>
  );
});
export default SvgVssx;
SvgVssx.iconName = 'vssx';
SvgVssx.displayName = 'SvgVssx';
